const ada = {
    pink: '#d70364',
    purple: '#752b77',
    blue: '#00b6ed',
    lightGrey: '#eceef0',
    grey: '#d0d4da',
    darkGrey: '#394956',
    darkGrey2: 'rgba(57, 73, 86, 0.7)',
    oddTableRow: '#f6f7f8',
    footer: '#24272d',
    red: '#F44336',
    sm_contentHeight: 'calc(100vh - (92px + 64px + 20px))',
    md_contentHeight: 'calc(100vh - (92px + 64px + 90px))',
};

export default ada;

